<div class="subscription-document-list lifeislife-light-list">

  <div class="loading-panel" *ngIf="loading$ | async">
    <!--    <div *ngFor="let i of Array(pageSize).fill(true)">-->
    <!--      <div class="loading-placeholder-row">-->
    <!--        <span>Chargement...</span>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>

  <div class="results-panel" *ngIf="(searchResults$ | async) != null && (loading$ | async) === false">
    <div *ngFor="let row of (searchResults$ | async).list" class="result-row"
         [class.clickable]="rowClickable"
         (click)="onRowClick(row,$event)"
    >
      <cf-subscription-document-list-item [subscriptionFile]="row"
      ></cf-subscription-document-list-item>
    </div>
  </div>

  <div class="paginator-panel">
    <p-paginator *ngIf="(loading$ | async) === false"
                 [alwaysShow]="false"
                 [first]="(paginationSource$ | async)?.offset"
                 [rows]="(paginationSource$ |async)?.length"
                 [totalRecords]="(searchResults$ | async)?.count"
                 [showJumpToPageDropdown]="false"
                 (onPageChange)="onPaginationChange($event)"
                 [style]="{'background-color': 'transparent'}"
    ></p-paginator>
  </div>

</div>
